import { useCallback } from 'react';

import { TrackingApi } from 'api/TrackingApi';
import { getScreenOrientationWithSizes } from 'helpers/device';

const PWA_INSTALL_BUTTON_PARAMETER = 'pwa_app_button';
const PWA_BANNER_EVENT_INFO_PARAMETER = 'pwa_banner';
const PWA_SYSTEM_BANNER_EVENT_INFO_PARAMETER = 'pwa_system';

export const usePWAAnalytics = () => {
  const trackPWAInstallButtonClick = useCallback(
    (payload: { buttonText: string }) => {
      TrackingApi.trackClick({
        info: PWA_INSTALL_BUTTON_PARAMETER,
        parameter: payload.buttonText,
        screen: getScreenOrientationWithSizes(),
      }).catch();
    },
    []
  );

  const trackPromotionPWAShow = useCallback((payload: { position: string }) => {
    TrackingApi.trackPopup({
      info: PWA_BANNER_EVENT_INFO_PARAMETER,
      operation: 'show',
      parameter: payload.position,
      screen: getScreenOrientationWithSizes(),
    }).catch();
  }, []);

  const trackPromotionPWASubmit = useCallback(
    (payload: { position: string }) => {
      TrackingApi.trackPopup({
        info: PWA_BANNER_EVENT_INFO_PARAMETER,
        operation: 'click',
        parameter: payload.position,
        screen: getScreenOrientationWithSizes(),
      }).catch();
    },
    []
  );

  const trackPromotionPWAClose = useCallback(
    (payload: { position: string }) => {
      TrackingApi.trackPopup({
        info: PWA_BANNER_EVENT_INFO_PARAMETER,
        operation: 'close',
        parameter: payload.position,
        screen: getScreenOrientationWithSizes(),
      }).catch();
    },
    []
  );

  const trackPWANativeDialogShow = useCallback(() => {
    TrackingApi.trackPopup({
      info: PWA_SYSTEM_BANNER_EVENT_INFO_PARAMETER,
      operation: 'show',
      screen: getScreenOrientationWithSizes(),
    }).catch();
  }, []);

  const trackPWAInstall = useCallback((isFromSystem) => {
    TrackingApi.trackPwaInstall({
      icon: '3',
      is_system: isFromSystem ? 1 : 0,
    }).catch();
  }, []);

  const trackPWANativeDialogSubmit = useCallback(() => {
    TrackingApi.trackPopup({
      info: PWA_SYSTEM_BANNER_EVENT_INFO_PARAMETER,
      operation: 'click',
      screen: getScreenOrientationWithSizes(),
    }).catch();
  }, []);

  const trackPWANativeDialogClose = useCallback(() => {
    TrackingApi.trackPopup({
      info: PWA_SYSTEM_BANNER_EVENT_INFO_PARAMETER,
      operation: 'close',
      screen: getScreenOrientationWithSizes(),
    }).catch();
  }, []);

  return {
    trackPWAInstallButtonClick,

    trackPromotionPWAShow,
    trackPromotionPWASubmit,
    trackPromotionPWAClose,
    trackPWANativeDialogShow,
    trackPWANativeDialogSubmit,
    trackPWANativeDialogClose,
    trackPWAInstall,
  };
};
